module.exports = __webpack_public_path__ + "static/img/scaniccid.312a7df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scaniccid.png
// module id = IZ/I
// module chunks = 1